import breakfast from './breakfast';
import lunch from './lunch';
import dinner from './dinner';

const fakeData = [...breakfast, ...lunch, ...dinner];

export default fakeData;